import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import CalendarIcon from '@material-ui/icons/CalendarToday';
//import {DateFormatInput} from 'material-ui-next-pickers'
import CardFenomene from './../../../fenomene_selection/components/CardFenomene';
import { TIME_SELECTION_CONTAINER } from './../../../../../constants/strings/StringsDashboard';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './../../../../../Actions/Dashboard';

class DaySelect extends Component {
    constructor(props) {
        super(props);
        this.ya = new Date();
        this.state = {
            date: new Date(this.ya.getFullYear(), this.ya.getMonth(), this.ya.getDate())
        }
    }
    onChangeDate = (date) => {
        let val = date.target.value.split('-');
        let resp = new Date(val[0], val[1] - 1, val[2]);
        this.props.actions.selectFilter({ id: this.ya.getTime(), value: this.setDateToString(resp)}, 'day')
        // this.setState({ date: resp });
    }

    setDateToString = (date) => {
        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
    }
    
    render() {
        const { date } = this.state;
        const fecha = (dato) => {
            let tal = new Date(dato);
            var date = tal.toISOString().substr(0, 10);
            return date;
        }
        return (
            // <Grid item xs={10} className="client-label" style={{ textAlign: 'center' }}>

            //     <input type={'date'} className={'date'} onChange={this.onChangeDate} defaultValue={fecha(date)}></input>
            //     {/*    <DateFormatInput 
            //         className="client-date-picker" 
            //         value={date} 
            //         onChange={this.onChangeDate} 
            //         max={new Date()}  
            //         dateFormat="dd/MM/yyyy"
            //     /> */}
            // </Grid>
            <Grid>
                <Grid>
                    <CardFenomene
                        title={TIME_SELECTION_CONTAINER.DAY}
                        groupbutton={
                            <Grid container  className="iconContainerFS" >
                                <Grid item xs={3}></Grid>
                                <Grid item xs={4} className="client-label" style={{ textAlign: 'center' }} >
                                    <input type={'date'} className={'date'} onChange={this.onChangeDate} defaultValue={fecha(date)}></input>
                                </Grid>
                                <Grid item xs={2} >
                                    <CalendarIcon className='client-label' style={{ marginTop: '23px' }} />
                                </Grid>
                            </Grid>
                        }
                    />
                </Grid>
            </Grid>
        )
    }
}


function mapDispathToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
    }
}
export default connect(null, mapDispathToProps)(DaySelect);